/**
 * 指挥系统地图画板工具（壳组件）
 * - 逻辑：hooks/useMapDrawingBoard → edit/tools/history/export
 * - UI：components/mapDrawingBoard/*
 * - 纯函数：utils/mapDrawingBoard/*
 *
 * 与 OrthoToolbox / 地球空白点击飞设备共用：onActiveChange → drawingToolsActiveRef
 */
import React from 'react';
import useMapDrawingBoard from '../hooks/useMapDrawingBoard';
import MapDrawingBoardView from './mapDrawingBoard/MapDrawingBoardView';
import './MapDrawingBoard.css';

export default function MapDrawingBoard(props) {
  const { mapReady } = props;
  const board = useMapDrawingBoard(props);
  if (!mapReady) return null;
  return <MapDrawingBoardView {...board} />;
}
